import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { ChevronRightIcon } from "../../../../../shared/icons/ChevronRight";
import styles from "./styles.module.css";

interface Props {
  handleCollapsedInput: () => void;
  className?: string;
}

export const CollapsedButton = ({ handleCollapsedInput, className }: Props) => {
  return (
    <AppIconButton
      onClick={handleCollapsedInput}
      buttonType={"outlined"}
      className={styles["chevron-button"]}
    >
      <ChevronRightIcon />
    </AppIconButton>
  );
};
